module.exports = __webpack_public_path__ + "img/tw_app_bar.d300e142.png";